/**
 * A vendor can mark current documents for removal; the removal travels with their next
 * comment-thread reply (`ReplyPayload.removesFileIds`). The toggle lives on the file rows
 * the vendor already sees (DocumentTable, the Documents-tab "Current files" list, the
 * locked questionnaire file list) — the parent owns the toggled ids and hands them to
 * both the rows and the ReplyComposer.
 */
export type ReplyRemoval = {
  isRemoving: (fileId: string) => boolean;
  onToggle: (fileId: string) => void;
  disabled?: boolean;
};

/**
 * Where removal is offered: vendor only, only where an attached file could become the
 * answer (replyAttachmentCanPromote), and only with something current to remove. A
 * single-file question that owes its file cannot drop it — the vendor Replaces it instead.
 */
export function replyRemoveAvailable(p: {
  role: 'vendor' | 'admin';
  canPromote: boolean;
  allowMultipleFiles: boolean;
  requiresFile: boolean;
  hasCurrentDocs: boolean;
}): boolean {
  return (
    p.role === 'vendor' &&
    p.canPromote &&
    p.hasCurrentDocs &&
    (p.allowMultipleFiles || !p.requiresFile)
  );
}

/** Flips one id in a removal list (the parent's toggle). */
export function toggleRemovalId(ids: string[], id: string): string[] {
  return ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id];
}
